import { useMediaQuery, useTheme } from '@mui/material';
import { useRef, useState } from 'react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { A11y, Navigation, Pagination, Scrollbar } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import SimuleAgora from '../button/SimuleAgora';

const ComoFuncionaBlockVD = () => {
  const [, setActiveIndex] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
  const swiperRef = useRef(null);

  return (
    <section
      id='comoFunciona'
      className='bg-white pt-12 pb-12 lg:pb-[140px] lg:pt-[80px] flex justify-center'
    >
      <div className='w-full max-w-7xl px-6'>
        {/* Header */}
        <header className='max-w-md mb-12 lg:mb-20 flex flex-col gap-2'>
          <h2 className='text-gray-500 block text-start text-base'>
            Como funciona
          </h2>
          <h3 className='text-main-text text-2xl lg:text-3xl font-light leading-tight text-start'>
            Entenda o modelo que garante sua economia
          </h3>
        </header>

        {/* Desktop Flex with arrows */}
        {!isMobile && (
          <div className='flex flex-col gap-12 items-center justify-center'>
            <div className='hidden lg:flex items-center justify-center gap-6'>
              {/* Card 1 */}
              <div className='flex flex-col items-center gap-8 relative'>
                <div className='bg-gray-100 rounded-2xl px-6 py-12 flex flex-col items-center text-center max-w-[540px]'>
                  <div className='w-16 h-16 bg-[#ffc000] rounded-full flex items-center justify-center absolute -top-6 left-1/2 transform -translate-x-1/2'>
                    <span className='text-white font-bold text-2xl'>1º</span>
                  </div>
                  <div className='my-6'>
                    <img
                      src='/tim/images/como-funciona/usinas-thopen.png'
                      alt='Usinas da Thopen'
                      className='w-full h-36 mb-4 object-cover'
                    />
                  </div>
                  <div className='flex flex-col gap-2'>
                    <h3 className='text-main-text font-bold text-lg'>
                      Usinas da Thopen
                    </h3>
                    <p className='text-main-text text-base'>
                      Geramos energia limpa nas nossas usinas como solar, biogás
                      e hídrica.
                    </p>
                  </div>
                </div>
              </div>
              {/* Arrow */}
              <div className='text-[#ffc000] text-3xl font-bold mb-6'>›</div>

              {/* Card 2 */}
              <div className='flex flex-col items-center gap-8 relative'>
                <div className='bg-gray-100 rounded-2xl px-6 py-12 flex flex-col items-center text-center max-w-[540px]'>
                  <div className='w-16 h-16 bg-[#ffc000] rounded-full flex items-center justify-center absolute -top-6 left-1/2 transform -translate-x-1/2'>
                    <span className='text-white font-bold text-2xl'>2º</span>
                  </div>
                  <div className='my-6'>
                    <img
                      src='/tim/images/como-funciona/distribuidora.png'
                      alt='Distribuidora'
                      className='w-full h-36 mb-4 object-cover'
                    />
                  </div>
                  <div className='flex flex-col gap-2'>
                    <h3 className='text-main-text font-bold text-lg'>
                      Distribuidora
                    </h3>
                    <p className='text-main-text text-base'>
                      Inserimos essa energia produzida direto na sua companhia
                      elétrica
                    </p>
                  </div>
                </div>
              </div>
              {/* Arrow */}
              <div className='text-[#ffc000] text-3xl font-bold mb-6'>›</div>

              {/* Card 3 */}
              <div className='flex flex-col items-center gap-8 relative'>
                <div className='bg-gray-100 rounded-2xl px-6 py-12 flex flex-col items-center text-center max-w-[540px] h-full'>
                  <div className='w-16 h-16 bg-[#ffc000] rounded-full flex items-center justify-center absolute -top-6 left-1/2 transform -translate-x-1/2'>
                    <span className='text-white font-bold text-2xl'>3º</span>
                  </div>
                  <div className='my-6'>
                    <img
                      src='/tim/images/como-funciona/sua-casa.png'
                      alt='Sua casa'
                      className='w-full h-36 mb-4 object-cover '
                    />
                  </div>
                  <div className='flex flex-col gap-2'>
                    <h3 className='text-main-text font-bold text-lg'>
                      Sua casa
                    </h3>
                    <p className='text-main-text text-base'>
                      Essa energia chega através da rede que já existe, sem
                      necessidade de obra.
                    </p>
                  </div>
                </div>
              </div>
              {/* Arrow */}
              <div className='text-[#ffc000] text-3xl font-bold mb-6'>›</div>

              {/* Card 4 */}
              <div className='flex flex-col items-center gap-8 relative'>
                <div className='bg-gray-100 rounded-2xl px-6 py-12 flex flex-col items-center text-center max-w-[540px]'>
                  <div className='w-16 h-16 bg-[#ffc000] rounded-full flex items-center justify-center absolute -top-6 left-1/2 transform -translate-x-1/2'>
                    <span className='text-white font-bold text-2xl'>4º</span>
                  </div>
                  <div className='my-6'>
                    <img
                      src='/tim/images/como-funciona/economia.png'
                      alt='Economia'
                      className='w-full h-32 mb-4 object-cover'
                    />
                  </div>
                  <div className='flex flex-col gap-2'>
                    <h3 className='text-main-text font-bold text-lg'>
                      Economia
                    </h3>
                    <p className='text-main-text text-base'>
                      O uso dessa energia limpa compensa a redução da sua conta
                      e você economiza todo mês.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <SimuleAgora title='Simule agora' variant='outline' />
          </div>
        )}

        {/* Mobile Swiper */}
        {isMobile && (
          <div className='relative w-full px-4 pb-16'>
            <Swiper
              ref={swiperRef}
              modules={[Navigation, Pagination, Scrollbar, A11y]}
              spaceBetween={16}
              slidesPerView={1}
              onSlideChange={(s) => setActiveIndex(s.activeIndex)}
              pagination={{ clickable: true }}
              autoHeight={true}
              className='!pb-12'
              style={{ overflow: 'visible', paddingBottom: '20px' }}
            >
              {/* Slide 1 */}
              <SwiperSlide>
                <div className='bg-[#f3f4f6] rounded-2xl pt-12 pb-10 px-8 mx-auto max-w-[320px] relative w-full h-full min-h-[380px] items-center justify-center flex flex-col'>
                  <div className='w-14 h-14 bg-[#ffc000] rounded-full flex items-center justify-center absolute -top-6 left-1/2 -translate-x-1/2'>
                    <span className='text-white font-bold text-xl'>1º</span>
                  </div>
                  <div className='mb-4'>
                    <img
                      src='/tim/images/como-funciona/usinas-thopen.png'
                      alt='Usinas da Thopen'
                      className='w-full h-36 object-contain'
                    />
                  </div>
                  <h3 className='text-center text-main-text font-bold text-lg mb-2'>
                    Usinas da Thopen
                  </h3>
                  <p className='text-center text-main-text text-base'>
                    Geramos energia limpa nas nossas usinas como solar, biogás e
                    hídrica.
                  </p>
                </div>
              </SwiperSlide>

              {/* Slide 2 */}
              <SwiperSlide>
                <div className='bg-[#f3f4f6] rounded-2xl pt-12 pb-10 px-4 mx-auto max-w-[320px] relative w-full h-full min-h-[380px] items-center justify-center flex flex-col'>
                  <div className='w-14 h-14 bg-[#ffc000] rounded-full flex items-center justify-center absolute -top-6 left-1/2 -translate-x-1/2'>
                    <span className='text-white font-bold text-xl'>2º</span>
                  </div>
                  <div className='mb-4'>
                    <img
                      src='/tim/images/como-funciona/distribuidora.png'
                      alt='Distribuidora'
                      className='w-full h-36 object-contain'
                    />
                  </div>
                  <h3 className='text-center text-main-text font-bold text-lg mb-2'>
                    Distribuidora
                  </h3>
                  <p className='text-center text-main-text text-base'>
                    Inserimos essa energia produzida direto na sua companhia
                    elétrica.
                  </p>
                </div>
              </SwiperSlide>

              {/* Slide 3 */}
              <SwiperSlide>
                <div className='bg-[#f3f4f6] rounded-2xl pt-12 pb-10 px-4 mx-auto max-w-[320px] relative w-full h-full min-h-[380px] items-center justify-center flex flex-col'>
                  <div className='w-14 h-14 bg-[#ffc000] rounded-full flex items-center justify-center absolute -top-6 left-1/2 -translate-x-1/2'>
                    <span className='text-white font-bold text-xl'>3º</span>
                  </div>
                  <div className='mb-4'>
                    <img
                      src='/tim/images/como-funciona/sua-casa.png'
                      alt='Sua casa'
                      className='w-full h-36 object-contain'
                    />
                  </div>
                  <h3 className='text-center text-main-text font-bold text-lg mb-2'>
                    Sua casa
                  </h3>
                  <p className='text-center text-main-text text-base'>
                    Essa energia chega através da rede que já existe, sem
                    necessidade de obra.
                  </p>
                </div>
              </SwiperSlide>

              {/* Slide 4 */}
              <SwiperSlide>
                <div className='bg-[#f3f4f6] rounded-2xl pt-12 pb-10 px-4 mx-auto max-w-[320px] relative w-full h-full min-h-[380px] items-center justify-center flex flex-col'>
                  <div className='w-14 h-14 bg-[#ffc000] rounded-full flex items-center justify-center absolute -top-6 left-1/2 -translate-x-1/2'>
                    <span className='text-white font-bold text-xl'>4º</span>
                  </div>
                  <div className='mb-4'>
                    <img
                      src='/tim/images/como-funciona/economia.png'
                      alt='Economia'
                      className='w-full h-36 object-contain'
                    />
                  </div>
                  <h3 className='text-center text-main-text font-bold text-lg mb-2'>
                    Economia
                  </h3>
                  <p className='text-center text-main-text text-base'>
                    O uso dessa energia limpa compensa a redução da sua conta e
                    você economiza todo mês.
                  </p>
                </div>
              </SwiperSlide>
            </Swiper>

            {/* Botões de navegação */}
            <button
              onClick={() => swiperRef.current?.swiper.slidePrev()}
              className='absolute left-0 top-1/3 transform -translate-y-1/2 bg-white text-[#ffc000] text-xl font-bold rounded-full w-10 h-10 shadow z-10 flex items-center justify-center'
              style={{ marginLeft: '-5px' }}
            >
              &lt;
            </button>
            <button
              onClick={() => swiperRef.current?.swiper.slideNext()}
              className='absolute right-0 top-1/3 transform -translate-y-1/2 bg-white text-[#ffc000] text-xl font-bold rounded-full w-10 h-10 shadow z-10 flex items-center justify-center'
              style={{ marginRight: '-5px' }}
            >
              &gt;
            </button>

            {/* Botão principal */}
            <div className='mt-8'>
              <SimuleAgora title='Simule agora' variant='outline' />
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default ComoFuncionaBlockVD;
